import { useState } from 'react';
import { styled } from '@mui/material/styles';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Backdrop } from '@mui/material';

export const Accordion = ({ detailsContent, summeryContent, name }) => {
  const [expanded, setExpanded] = useState(false);

  const handleChange = (name) => (event, newExpanded) => {
    setExpanded(newExpanded ? name : false);
  };

  return (
    <>
      <Backdrop
        sx={{
          zIndex: 4,
          background: 'rgba(112, 112, 112, 0.6)',
          transition: 'ease-in-out 0.2s !important'
        }}
        open={expanded === name}
        onClick={() => setExpanded(null)}
      />
      <StyledAccordion
        expanded={expanded === name}
        onChange={handleChange(name)}
      >
        <AccordionSummary id={name} expandIcon={<KeyboardArrowDownIcon />}>
          {summeryContent}
        </AccordionSummary>
        <AccordionDetails>{detailsContent}</AccordionDetails>
      </StyledAccordion>
    </>
  );
};

const StyledAccordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ expanded }) => ({
  position: 'absolute',
  zIndex: '999',
  padding: 0,
  background: '#F5F5F5',
  width: '100%',
  borderRadius: '16px',
  overflow: 'hidden',
  boxShadow: '1px 1px 2px 0px #00000029',
  border: '1px solid #FFFFFF',
  '&:not(:last-child)': {
    borderBottom: 0
  },
  '&:before': {
    display: 'none'
  }
}));
const AccordionSummary = styled((props) => <MuiAccordionSummary {...props} />)(
  ({ theme }) => ({
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-content': {
      margin: 0
    }
  })
);
const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  margin: 0,
  padding: 0
}));
